import Link from "@mui/material/Link";
import { FC } from "react";
import { TPageUrl } from "../../../routing/accessMap";
import { Link as RouterLink } from "react-router-dom";

const LinkSignUpForm: FC<{ url?: TPageUrl }> = ({ url = '/oauth/signUp'}) => (  
  <Link component={RouterLink} to={url} variant='body2'>
    Don't have an account? Sign Up
  </Link>  
);

export default LinkSignUpForm;
